export const pains: string[] = [
  'Conflictos que explotan sin que sepas cómo bajarlos.',
  'Tu hijo no comparte nada. Responde con monosílabos o silencio.',
  'Cada intento de conversación termina en grito, portazo o cierre emocional.',
  'Le quitaste pantallas y la guerra fue tan fuerte que volviste a dejarle todo.',
  'No sabés si lo que hace es rebeldía normal o una bandera roja seria.',
  'Te sentís como un policía, no como su padre o madre. El vínculo está roto.',
  'La cena familiar desapareció. Cada uno en su cuarto con su pantalla.',
  'Estás agotado/a, culpable y asustado/a de que siga empeorando.',
]

export interface CostRow {
  item: string
  cost: string
}

export const costRows: CostRow[] = [
  { item: 'Horas buscando respuestas por mes', cost: '20+ horas' },
  { item: 'Conflictos sin protocolo', cost: 'Incalculable' },
  { item: 'Terapia sin raíz estructural', cost: '$1.500–$3.000' },
  { item: 'Estrés, culpa y noches sin dormir', cost: 'Infinito' },
]
